// import { useEffect } from 'react';
// import { useAppSelector } from '../redux/store';
// import { selectPurchaseSuccess } from '../redux/features/features.selector';

// /**
//  * Hook to automatically refetch data on purchase success
//  */
// export function useRefreshOnPurchase(refetchFn: () => Promise<void> | void) {
//   const purchaseSuccess = useAppSelector(selectPurchaseSuccess);

//   useEffect(() => {
//     if (purchaseSuccess) {
//       try {
//         const result = refetchFn();
//         if (result instanceof Promise) {
//           result.catch(error => {
//             console.error('Error refreshing data on purchase success:', error);
//           });
//         }
//       } catch (error) {
//         console.error('Error refreshing data on purchase success:', error);
//       }
//     }
//   }, [purchaseSuccess, refetchFn]);
// }

// /**
//  * Hook to trigger a callback when a purchase is successful
//  * Useful for custom logic after package purchase
//  */
// export function useOnPurchaseSuccess(callback: () => void) {
//   const purchaseSuccess = useAppSelector(selectPurchaseSuccess);

//   useEffect(() => {
//     if (purchaseSuccess && callback) {
//       callback();
//     }
//   }, [purchaseSuccess, callback]);
// }
import { useEffect, useRef } from 'react';
// import { useEffect } from 'react';
import { useAppSelector } from '../redux/store';
import { selectPurchaseSuccess } from '../redux/features/features.selector';


export function useRefreshOnPurchase(refetchFn: () => Promise<void> | void) {
  const purchaseSuccess = useAppSelector(selectPurchaseSuccess);
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (!purchaseSuccess || hasRunRef.current) return;

    hasRunRef.current = true;

    try {
      const result = refetchFn();
      if (result instanceof Promise) {
        result.catch(err =>
          console.error('Error refreshing data on purchase success:', err)
        );
      }
    } catch (err) {
      console.error('Error refreshing data on purchase success:', err);
    }
  }, [purchaseSuccess]);
}
export function useOnPurchaseSuccess(callback: () => void) {
  const purchaseSuccess = useAppSelector(selectPurchaseSuccess);
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (!purchaseSuccess || hasRunRef.current) return;

    hasRunRef.current = true;
    callback();
  }, [purchaseSuccess]);
}
